import React, { useState } from 'react';
import Card from 'v3/components/Card';
import Text from 'v3/components/Text';
import CardHeaderComponent from '../../components/CardHeaderComponent';
import HeaderTotalSummary from '../../components/HeaderTotalSummary';
import { useFreightValues } from '../../context';
import ValueDetailsRow from '../../components/ValueDetailsRow';
import { SummaryRow } from '../../components/SummaryRow';
import ExtraFields from '../../components/ExtraFields';

export default function ShipmentDiscountsShow() {
  const { totalShipmentDiscounts, discountsTags, shipmentDiscounts, shipmentDiscountsExtraFields } =
    useFreightValues();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Card containerCardBoxShadow="0px 0px 10px rgba(0, 0, 0, 0.1)">
      <CardHeaderComponent
        label="Descontos ao transportador"
        isOpen={isOpen}
        onToggleCard={() => setIsOpen(!isOpen)}
        tooltipContent="Se caracteriza todo desconto que será feito depois de tirar a margem (Taxa administrativa)."
        totalsSection={
          <HeaderTotalSummary
            label="Valor Descontos"
            totalInReal={totalShipmentDiscounts?.total}
            totalInDollar={totalShipmentDiscounts?.totalDollarValue}
          />
        }
        hasTagsRow
        tagsContent={discountsTags}
      />
      {isOpen && (
        <>
          <ValueDetailsRow
            label="Taxa de emissão"
            value={shipmentDiscounts?.issueRate?.value}
            dollarValue={shipmentDiscounts?.issueRate?.dollarValue}
            hasTooltip
            tooltipContent="Valor da taxa para emissão dos documentos, é preenchido automaticamente conforme nível de associado e pode ser editado pelo usuário."
          />
          <>
            <Text type="regular" weight={500}>
              Valores extras
            </Text>
            <ExtraFields show fields={shipmentDiscountsExtraFields || []} />
          </>
          <SummaryRow
            label="Valor Descontos"
            totalInReal={totalShipmentDiscounts?.total}
            totalInDollar={totalShipmentDiscounts?.totalDollarValue}
            id="desconto"
          />
        </>
      )}
    </Card>
  );
}
